import type { QueryHookOptions } from "@apollo/client";
import { gql, useLazyQuery, useQuery } from "@apollo/client";

import { EMERSON_CATALOG_PRODUCT_WITH_VARIANT } from "@emerson/data/splinters/CatalogProductWithVariant.fragment";
import type { EmersonCatalogProductWithVariant } from "@emerson/data/splinters/CatalogProductWithVariant.fragment";
import { EMERSON_CATALOG_PRODUCT_WITH_VARIANT_OPEN } from "@emerson/data/splinters/CatalogProductWithVariantOpen.fragment";
import type { ImageFilterObject } from "@shared/types/graphqlGenerated";

const Product_Emerson_Query = gql`
  query Product_Emerson_Query(
    $productId: ID!
    $filters: ImageFilterObject = {}
    $isUnauthenticated: Boolean = false
  ) {
    viewer {
      product: node(id: $productId) {
        ... on Product {
          containsCbd @skip(if: $isUnauthenticated)
          nonShippableStates @skip(if: $isUnauthenticated) {
            id
            name
            abbr
          }

          ...EmersonCatalogProductWithVariant @skip(if: $isUnauthenticated)
          ...EmersonCatalogProductWithVariantOpen @include(if: $isUnauthenticated)
        }
      }
    }
  }
  ${EMERSON_CATALOG_PRODUCT_WITH_VARIANT}
  ${EMERSON_CATALOG_PRODUCT_WITH_VARIANT_OPEN}
`;

interface CatalogProductQueryData {
  viewer: {
    product: EmersonCatalogProductWithVariant;
  };
}

type CatalogProductWithVariant = EmersonCatalogProductWithVariant;

interface Variables {
  productId: string;
  filters?: ImageFilterObject;
  isUnauthenticated?: boolean;
}

const useCatalogProductQuery = (options?: QueryHookOptions<CatalogProductQueryData, Variables>) => {
  return useQuery<CatalogProductQueryData, Variables>(Product_Emerson_Query, options);
};

const useCatalogProductLazyQuery = (
  options?: QueryHookOptions<CatalogProductQueryData, Variables>
) => useLazyQuery<CatalogProductQueryData, Variables>(Product_Emerson_Query, options);

export type { CatalogProductQueryData, CatalogProductWithVariant };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useCatalogProductQuery, useCatalogProductLazyQuery, Product_Emerson_Query };
